import { render } from "./HelpAhsVdhMedBoard.vue?vue&type=template&id=2a45f0e9&scoped=true"
import script from "./HelpAhsVdhMedBoard.vue?vue&type=script&lang=js"
export * from "./HelpAhsVdhMedBoard.vue?vue&type=script&lang=js"

import "./HelpAhsVdhMedBoard.vue?vue&type=style&index=0&id=2a45f0e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a45f0e9"]])

export default __exports__